import { onUnmounted, watch } from 'vue'
import { useNotificationStore } from '@/stores/notifications'
import { useAuth } from '@/composables/useAuth'
import { hasAdminRole } from '@/types/auth'

export function useNotifications() {
  const store = useNotificationStore()
  const { state } = useAuth()

  // 管理员不启用用户端通知中心
  const isAdmin = () => hasAdminRole(state.currentUser?.role)

  // 当前会话是否已初始化过（登录→登出→再登录需重新初始化）
  let initialized = false

  // P1-fix: 认证状态就绪/变化时初始化通知中心（偏好 + 消息列表 + 未读数 + 轮询），
  // 侧边栏/顶栏角标无需等用户进入消息中心或切换标签页才出现。
  // watch 而非 onMounted 直读：auth 状态在路由守卫/登录动作中才就绪，且登录发生在
  // App 已挂载之后，onMounted 不会再次触发。
  // 页面可见性变化后的刷新/暂停/恢复由 store.startPolling 注册的监听负责，
  // 这里不重复注册——两份监听会让每次切回页面把未读数与即将过期计数各发两遍。
  watch(
    () => state.isAuthenticated,
    authenticated => {
      if (authenticated && !isAdmin()) {
        if (!initialized) {
          initialized = true
          // initialize 内部逐段容错且必启轮询；此处 catch 仅防未处理的 promise 拒绝
          store.initialize().catch(() => {})
        }
      } else {
        // 登出：停止轮询并重置标志，允许下次登录重新初始化
        initialized = false
        store.stopPolling()
      }
    },
    { immediate: true },
  )

  onUnmounted(() => {
    store.stopPolling()
  })

  return { store }
}
